export default "__VITE_ASSET__R91RW7m3__"